export default "__VITE_ASSET__9bHZBDao__"